import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { FailedSlipViewModel } from './result-failed-slip.model';

@Component({
    selector: 'bs-digital-result-failed-slip',
    templateUrl: './result-failed-slip.component.html',
    styleUrls: ['./result-failed-slip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultFailedSlipComponent {
    @Input() slip: FailedSlipViewModel;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    messages: IBetslipMessages;
    module = EpcotModule.Betslip;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        this.messages = messageProvider.getMessages();
    }
}
